import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingSpin from '../LoadingSpin';
import FoldingPanel, { FoldingListItem } from './FoldingPanel';

export interface FoldingListProps {
  id?: string;
  items: FoldingListItem[];
  hasMore?: boolean;
  showEnd?: boolean;
  onEndReached?: () => void;
}

export default function FoldingList({
  items = [],
  onEndReached,
  showEnd = true,
  hasMore = false,
  id = 'scrollableDiv',
}: FoldingListProps) {

  const [t] = useTranslation(['common']);

  return (
    <div
      id={id}
      style={{ height: '90%', overflow: 'auto' }}
      className="py-4 relative block">

      <InfiniteScroll
        scrollableTarget={id}
        dataLength={items.length}
        next={onEndReached}
        hasMore={hasMore}
        loader={<LoadingSpin text="" className="py-2" />}
        endMessage={showEnd && !hasMore ? (
          <p style={{ textAlign: 'center', padding: '0.5rem' }}>
            <b>{t('common:messages.end-of-list')}</b>
          </p>
        ) : <></>}>
        {items.map((item, index) => (
          <FoldingPanel key={index} {...item} />
        ))}
      </InfiniteScroll>

    </div>
  );
}
